export const ICO_MOON     = 'M12 3a9 9 0 1 0 9 9c0-.46-.04-.92-.1-1.36A5.39 5.39 0 0 1 12.5 3.1 9.06 9.06 0 0 0 12 3z';
export const ICO_LAYERS   = 'm12 2 10 6-10 6L2 8l10-6z M2 16l10 6 10-6 M2 12l10 6 10-6';
export const ICO_BRANCH   = 'M6 3v12 M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M18 9a9 9 0 0 1-9 9';
export const ICO_ROCKET   = 'M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09zM12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z';
export const ICO_EXTERNAL = 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14 21 3';
export const ICO_CHEVRIGHT= 'm9 18 6-6-6-6';
export const ICO_ALERT    = 'M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01';
export const ICO_REFRESH  = 'M3 12a9 9 0 0 1 15-6.7L21 8M21 3v5h-5M21 12a9 9 0 0 1-15 6.7L3 16M3 21v-5h5';

export const ICO_BOX    = 'm21 16-9 5-9-5V8l9-5 9 5v8zM3.3 7 12 12l8.7-5M12 22V12';
export const ICO_FLASK  = 'M10 2v7.31L4 21h16l-6-11.69V2M8 2h8M7 14h10';
export const ICO_SHIELD = 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z';
export const ICO_KEY    = 'M21 2 15 8M17.5 6.5 22 11M11 7a4 4 0 1 1-4 4M3 21l5-5M7 16l1.5 1.5';
export const ICO_CHECK  = 'M20 6 9 17l-5-5';
export const ICO_XMARK  = 'M18 6 6 18M6 6l12 12';
export const ICO_EXPAND = 'M16 3h5v5M21 3l-7 7M8 21H3v-5M3 21l7-7';
export const ICO_SKIP   = 'M5 4l10 8-10 8V4zM19 5v14';
export const ICO_SEARCH = 'M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z';

export const NIGHTLY_STEP_ORDER = [
  'build_docker', 'construct_build', 'py_tests', 'maven_build', 'ai_platform_unit_tests', 'ai_platform_tests',
  'construct_tests', 'askcollate_e2e', 'java_it_search', 'sso_login',
  'aut_mysql_v2', 'aut_psql_v2',
  'aut_mysql_kind', 'aut_psql_kind',
  'omd_postgresql', 'omd_mysql',
  'deploy_test',
  'vulnerability_scan_openmetadata', 'vulnerability_scan_collate_ingestion',
  'vulnerability_scan_collate', 'vulnerability_scan_collate_snyk',
  'vulnerability_scan_hybrid', 'vulnerability_scan_hybrid_snyk',
  'vulnerability_scan_ai_platform', 'ai_platform_security_scan',
  'vulnerability_scan_construct', 'vulnerability_scan_construct_snyk',
  'replicate_customers',
  'changelog',
];

export const EXTERNAL_NIGHTLY_OPERATION_KEYS = [
  'deploy_test',
];

// Steps that report on the build rather than validate it: shown in their own section and
// left out of the run's Steps count.
export const NON_VALIDATION_STEP_KEYS = [
  'changelog',
];

export const AUT_NIGHTLY_OPERATION_KEYS = [
  'aut_mysql_v2',
  'aut_psql_v2',
  'aut_mysql_kind',
  'aut_psql_kind',
];

export const NIGHTLY_STEP_CONFIG = {
  build_docker:               { name: 'build_docker_images',      label: 'Build Docker Images'       },
  construct_build:            { name: 'construct_build',          label: 'Construct Build'           },
  py_tests:                   { name: 'python_tests',             label: 'Python Tests'              },
  maven_build:                { name: 'maven_build',              label: 'Maven Build (Postgres)'    },
  ai_platform_unit_tests:     { name: 'ai_platform_unit_tests',   label: 'AI Platform Unit Tests'    },
  ai_platform_tests:          { name: 'ai_platform_tests',        label: 'AI Platform Tests'         },
  construct_tests:            { name: 'construct_tests',          label: 'Construct Tests'           },
  askcollate_e2e:             { name: 'askcollate_e2e',           label: 'AskCollate E2E'            },
  java_it_search:             { name: 'java_it_search',           label: 'Java IT (Search)'          },
  sso_login:                  { name: 'sso_login',                label: 'SSO Login (Playwright)'    },
  aut_mysql_v2:               { name: 'aut_mysql_v2',             label: 'AUT (MySQL V2)'            },
  aut_psql_v2:                { name: 'aut_psql_v2',              label: 'AUT (Postgres V2)'         },
  aut_mysql_kind:             { name: 'aut_mysql_kind',           label: 'AUT (MySQL · kind)'        },
  aut_psql_kind:              { name: 'aut_psql_kind',            label: 'AUT (Postgres · kind)'     },
  omd_postgresql:             { name: 'omd_e2e_postgres',         label: 'OMD E2E (Postgres)'        },
  omd_mysql:                  { name: 'omd_e2e_mysql',            label: 'OMD E2E (MySQL)'           },
  deploy_test:                { name: 'argocd_deploy',            label: 'Deploy to Test Instance'   },
  vulnerability_scan_openmetadata: { name: 'vuln_scan_openmetadata',  label: 'Vuln Scan (OpenMetadata)'         },
  vulnerability_scan_collate_ingestion: { name: 'vuln_scan_collate_ingestion', label: 'Vuln Scan (Collate Ingestion)' },
  vulnerability_scan_collate:      { name: 'vuln_scan_collate',        label: 'Vuln Scan (Collate)'              },
  vulnerability_scan_collate_snyk: { name: 'vuln_scan_collate_snyk',   label: 'Vuln Scan (Collate · Snyk)'       },
  vulnerability_scan_hybrid:       { name: 'vuln_scan_hybrid',         label: 'Vuln Scan (Hybrid Runner)'       },
  vulnerability_scan_hybrid_snyk:  { name: 'vuln_scan_hybrid_snyk',    label: 'Vuln Scan (Hybrid Runner · Snyk)' },
  vulnerability_scan_ai_platform:  { name: 'vuln_scan_ai_platform',    label: 'Vuln Scan (AI Platform)'          },
  ai_platform_security_scan:       { name: 'ai_platform_security_scan',label: 'Vuln Scan (AI Platform · Snyk)'   },
  vulnerability_scan_construct:      { name: 'vuln_scan_construct',      label: 'Vuln Scan (Construct)'            },
  vulnerability_scan_construct_snyk: { name: 'vuln_scan_construct_snyk', label: 'Vuln Scan (Construct · Snyk)'     },
  replicate_customers:        { name: 'replicate_customers',      label: 'Replicate Customers'       },
  changelog:                  { name: 'changelog',                label: 'Changelog'                 },
};
export const ICO_CLOUD  = 'M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z';
